import React from 'react';
import axios from 'axios';
import { user_token } from '../../../services/Auth';

var token = localStorage.getItem(user_token);

export default class LifeHabits extends React.Component {
  state = {
    consulta: [],
    alcoholism: true,
    smoking: true,
    activity: true,
  }

  componentDidMount() {
    axios.get(`http://api-convida.herokuapp.com/user/${this.props.life}`, {headers: {'x-access-token': token}})
      .then(res => {
        const consulta = res.data;
        this.setState({ consulta });
      })
  }

  render() {
    let {alcoholism} = this.state;
    const renderAlcoholism = ()=>{
      if(alcoholism){
        return <p>Sim</p>
      } else{
        return <p>Não</p>
      }
    }
    let {smoking} = this.state;
    const renderSmoking = ()=>{
      if(smoking){
        return <p>Sim</p>
      } else{
        return <p>Não</p>
      }
    }
    let {activity} = this.state;
    const renderActivity = ()=>{
      if(activity){
        return <p>Sim</p>
      } else{
        return <p>Não</p>
      }
    }
    return (
      <ul>
        { this.state.consulta.map(details => 
        <>
          <p id="RI-Title-Cadastro-Paciente" >Alcoolismo: </p>{renderAlcoholism()}
          <p id="RI-Title-Cadastro-Paciente" >Familiares Alcólatras: </p><p>{details.medical_record.life_habits.alcoholism_amount}</p>
          <p id="RI-Title-Cadastro-Paciente" >Cirurgia: </p><p>{details.medical_record.life_habits.surgery}</p>
          <p id="RI-Title-Cadastro-Paciente" >Tabagismo: </p>{renderSmoking()}
          <p id="RI-Title-Cadastro-Paciente" >Familiares Fumantes: </p><p>{details.medical_record.life_habits.smoking_amount}</p>
          <p id="RI-Title-Cadastro-Paciente" >Atividade Física: </p>{renderActivity()}
        </>)}
      </ul>
    )
  }
}